import { useSelector } from 'react-redux';
import State from 'store/State';
import { selectStrategyParametersState } from '../selectors';
import { ChannelDestination } from 'communication/Channel';
import {
    StrategyParametersStreamState,
    StrategyParametersStreamDataState,
} from './StrategyParametersStreamState';
import { useWidgetContext } from 'widgets/WidgetContext';

export const selectStreamState: (
    state: State,
    widgetKey: string
) => StrategyParametersStreamState | undefined = (state, widgetKey) => {
    const widgetState = selectStrategyParametersState(state, widgetKey);
    return widgetState?.stream;
};

export const selectStreamData: (
    state: State,
    widgetKey: string
) => StrategyParametersStreamDataState | undefined = (state, widgetKey) => {
    const streamState = selectStreamState(state, widgetKey);
    return streamState?.data;
};

export const selectStreamKey: (
    state: State,
    widgetKey: string
) => string | undefined = (state, widgetKey) => {
    const streamState = selectStreamState(state, widgetKey);
    return streamState?.streamKey;
};

export const selectStreamKeyByStartChannel =
    (startChannelDestination: ChannelDestination) =>
    (state: State, widgetKey: string): string | undefined => {
        const dataState: StrategyParametersStreamDataState | undefined =
            selectStreamData(state, widgetKey);

        if (dataState) {
            switch (startChannelDestination) {
                case 'startStrategyParamsHistByOrderIdsStream':
                    return dataState.streamKeys.single;
                case 'startStrategyParamsCurByOrderIdsStream':
                    return dataState.streamKeys.multiple;
            }
        }

        return undefined;
    };

export const useSelectStrategyParametersStreamDataState = () => {
    const { widgetKey } = useWidgetContext();
    return useSelector((state: State) => selectStreamData(state, widgetKey));
};
